import React from 'react';
import './Partners.css';

const Partners = () => {
  return (
    <div className="partners-section">
      <h2 className="partners-heading">
        We’ve been partnering with national brands for several years.
      </h2>
      
      <div className="partners-logos">
        <div className="partner-logo">
          <img 
            src="https://myorderportal.com/pictures/frankspizzaoakridge.png" 
            alt="Frank's Pizza Oak Ridge" 
            className="partner-image"
          />
        </div>

        <div className="partner-logo">
          <img 
            src="https://myorderportal.com/pictures/somersetpizza.png" 
            alt="Somerset Pizza" 
            className="partner-image"
          />
        </div>

        <div className="partner-logo">
          <img 
            src="https://myorderportal.com/pictures/unclesalssparta.png" 
            alt="Uncle Sals Pizza" 
            className="partner-image"
          />
        </div>

        <div className="partner-logo">
          <img 
            src="https://myorderportal.com/pictures/mondopizzarandolph.png" 
            alt="Mondo Pizza Randolph" 
            className="partner-image"
          />
        </div>
        <div className="partner-logo">
          <img 
            src="https://myorderportal.com/pictures/annabelspizzaunionville.png" 
            alt="Annabel's Pizza Unionville" 
            className="partner-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Partners;
